__webpack_require__.p = "https://teccom-portal.qa.tecalliance.cloud/";